/* KG 2026-10-09 B1 pilot (chat 4): story-circle strip + ONE shared full-screen player. Loaded only by sections/kg-shorts-strip.liquid.
   iOS rule: showModal() + src + play() all run synchronously inside the tap handler (no await / timer / rAF before play()). */
(function () {
  if (window.__kgShorts) return; window.__kgShorts = 1;
  var W = window, D = document, util = null;
  try { import('@theme/utilities').then(function (m) { util = m; }, function () {}); } catch (e) {}

  var live = !!(W.Shopify && Shopify.theme && Shopify.theme.role === 'main' && !Shopify.designMode);
  var LOG = W.__kgShortsLog = [];
  var cfg = {}, clips = [], idx = 0, dlg, v, E = {}, fills = [], opener, opened = false, pushed = false;
  var blocked = false, holding = false, switching = false, t0 = 0, clipMs = 0, totalMs = 0, started = {}, raf = 0, clr = 0;
  /* 2026-10-20 mod clips: ~1 s silent clips replay `loops` times before the next one; they have no sound, so no sound button */
  var loopN = 0, curSilent = false, silentMuted = false;

  function parse(root) {
    try { var j = JSON.parse(root.querySelector('[data-kgs-json]').textContent); return { cfg: j.cfg || {}, clips: j.clips || [] }; }
    catch (e) { return { cfg: {}, clips: [] }; }
  }
  function use(root) { var p = parse(root); cfg = p.cfg; clips = p.clips; }
  function qa() { try { return /\.qa$/.test(localStorage.getItem('kg_ab_r26') || ''); } catch (e) { return false; } }

  /* analytics: GA4 + Clarity, live main theme + template suffix builder-b only; never QA-marked browsers */
  function ga(name, x) {
    var p = { short_place: cfg.place || 'pdp_strip', short_ui: 'B1', page_type: cfg.pageType || '' };
    for (var k in x) p[k] = x[k];
    var why = !live ? 'not-live' : cfg.suffix !== 'builder-b' ? 'suffix' : qa() ? 'qa' : '';
    LOG.push({ e: name, p: p, sent: !why, why: why });
    if (why) return;
    try { if (W.gtag) gtag('event', name, p); } catch (e) {}
    try { if (W.clarity) { clarity('set', 'short_ui', 'B1'); if (name === 'short_open') clarity('event', 'short_open'); } } catch (e) {}
  }

  /* seen state (per device) */
  function seenGet() { try { return JSON.parse(localStorage.getItem('kg_shorts_seen') || '[]'); } catch (e) { return []; } }
  function seenAdd(id) {
    try { var a = seenGet(); if (a.indexOf(id) < 0) { a.push(id); localStorage.setItem('kg_shorts_seen', JSON.stringify(a)); } } catch (e) {}
  }
  function paint() {
    var a = seenGet();
    D.querySelectorAll('[data-kgs]').forEach(function (r) {
      var c = parse(r).clips;
      r.querySelectorAll('.kgs__item').forEach(function (b) {
        var cl = c[+b.getAttribute('data-kgs-i')];
        if (cl && a.indexOf(cl.id) > -1) b.setAttribute('data-seen', ''); else b.removeAttribute('data-seen');
      });
    });
  }

  function lock() { try { if (util) util.lockScroll(dlg); else D.documentElement.setAttribute('scroll-lock', ''); } catch (e) {} }
  function unlock() { try { if (util) util.unlockScroll(dlg); else D.documentElement.removeAttribute('scroll-lock'); } catch (e) {} }

  var I_X = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var I_SPK = '<path d="M4 9v6h4l5 4V5L8 9H4z" fill="#fff"/>';
  var I_ON = '<svg class="kgs-p__on" viewBox="0 0 24 24" aria-hidden="true">' + I_SPK + '<path d="M16 8.5a5 5 0 010 7M18.5 6a8.5 8.5 0 010 12" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';
  var I_OFF = '<svg class="kgs-p__off" viewBox="0 0 24 24" aria-hidden="true">' + I_SPK + '<path d="M16.5 9.5l5 5M21.5 9.5l-5 5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';

  function build() {
    if (dlg) return;
    dlg = D.createElement('dialog');
    dlg.className = 'kgs-p'; dlg.setAttribute('dir', 'rtl'); dlg.setAttribute('aria-label', 'فيديوهات كلين');
    dlg.innerHTML = '<div class="kgs-p__box">' +
      '<video class="kgs-p__video" playsinline webkit-playsinline preload="auto"></video>' +
      '<div class="kgs-p__shade kgs-p__shade--t"></div><div class="kgs-p__shade kgs-p__shade--b"></div>' +
      '<div class="kgs-p__gest"></div><div class="kgs-p__bars" aria-hidden="true"></div>' +
      '<button type="button" class="kgs-p__ib kgs-p__x" aria-label="إغلاق">' + I_X + '</button>' +
      '<button type="button" class="kgs-p__ib kgs-p__snd" aria-label="تشغيل الصوت">' + I_ON + I_OFF + '</button>' +
      '<button type="button" class="kgs-p__big" aria-label="تشغيل" hidden><svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1l7 4-7 4z" fill="#fff"/></svg></button>' +
      '<button type="button" class="kgs-p__unmute" hidden>🔊 اضغط للصوت</button>' +
      '<span class="kgs-p__tag"></span>' +
      '<div class="kgs-p__card"><img class="kgs-p__thumb" alt="" width="52" height="52"><p class="kgs-p__title"></p>' +
      (cfg.ctaMode === 'link' ? '<a class="kgs-p__cta" href="#"></a>' : '<button type="button" class="kgs-p__cta"></button>') + '</div>' +
      '<p class="kgs-p__sr" aria-live="polite"></p></div>';
    D.body.appendChild(dlg);
    var q = function (s) { return dlg.querySelector(s); };
    v = q('video'); v.playsInline = true; v.disablePictureInPicture = true;
    E = { bars: q('.kgs-p__bars'), x: q('.kgs-p__x'), snd: q('.kgs-p__snd'), big: q('.kgs-p__big'), unmute: q('.kgs-p__unmute'),
      tag: q('.kgs-p__tag'), thumb: q('.kgs-p__thumb'), title: q('.kgs-p__title'), cta: q('.kgs-p__cta'), sr: q('.kgs-p__sr'), gest: q('.kgs-p__gest') };

    E.x.addEventListener('click', closePlayer);
    E.snd.addEventListener('click', function () { if (v.muted) soundOn(); else v.muted = true; });
    E.unmute.addEventListener('click', soundOn);
    E.big.addEventListener('click', function () { big(false); play(); });
    E.cta.addEventListener('click', function () {
      if (cfg.ctaMode === 'link') ga('short_product_click', { short_id: clips[idx].id, product_handle: clips[idx].id });
      else closePlayer();
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closePlayer(); });
    dlg.addEventListener('close', cleanup);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closePlayer(); });
    dlg.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(idx + 1); else if (e.key === 'ArrowRight') go(idx - 1);
    });
    v.addEventListener('playing', onPlaying);
    v.addEventListener('pause', onPause);
    v.addEventListener('ended', onEnded);
    v.addEventListener('volumechange', uiSound);
    v.addEventListener('error', function () { if (opened) big(true); });
    D.addEventListener('visibilitychange', function () { if (opened && D.hidden) v.pause(); });

    /* gestures: tap left third = next, right third = previous (RTL), swipe up = next, swipe down = close, hold = pause */
    var g = E.gest, sx = 0, sy = 0, down = false, ht = 0;
    g.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      down = true; sx = e.clientX; sy = e.clientY; holding = false; clearTimeout(ht);
      ht = setTimeout(function () { holding = true; v.pause(); }, 250);
      try { g.setPointerCapture(e.pointerId); } catch (x) {}
    });
    g.addEventListener('pointerup', function (e) {
      if (!down) return; down = false; clearTimeout(ht);
      if (holding) { holding = false; play(); return; }
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dy) > 50 && Math.abs(dy) > Math.abs(dx)) { if (dy < 0) go(idx + 1); else closePlayer(); return; }
      if (Math.abs(dx) < 12 && Math.abs(dy) < 12) {
        var r = g.getBoundingClientRect(), x = (e.clientX - r.left) / r.width;
        if (x < 1 / 3) go(idx + 1); else if (x > 2 / 3) go(idx - 1);
      }
    });
    g.addEventListener('pointercancel', function () { down = false; clearTimeout(ht); if (holding) { holding = false; play(); } });
  }

  function pick(c) {
    var hls = '', mp4 = [], s = c.src || [], i;
    for (i = 0; i < s.length; i++) {
      if (s[i].f === 'm3u8') hls = s[i].u; else if (s[i].f === 'mp4') mp4.push(s[i]);
    }
    if (hls && v.canPlayType('application/vnd.apple.mpegurl')) return hls;
    mp4.sort(function (a, b) { return a.h - b.h; });
    var want = (W.innerWidth * (W.devicePixelRatio || 1) > 700) ? 1080 : 720;
    for (i = 0; i < mp4.length; i++) if (mp4[i].h >= want) return mp4[i].u;
    return mp4.length ? mp4[mp4.length - 1].u : (hls || '');
  }

  function big(on) { if (E.big) E.big.hidden = !on; }
  function uiSound() {
    if (!E.snd) return;
    E.snd.classList.toggle('is-off', v.muted);
    E.snd.setAttribute('aria-label', v.muted ? 'تشغيل الصوت' : 'كتم الصوت');
    E.unmute.hidden = !(blocked && v.muted) || curSilent;
  }
  function soundOn() {
    v.muted = false; blocked = false; uiSound();
    ga('short_sound', { short_id: clips[idx].id });
    if (v.paused && !holding) play();
  }
  function flush() { if (t0) { var d = Date.now() - t0; t0 = 0; clipMs += d; totalMs += d; } }

  function play() {
    var p; try { p = v.play(); } catch (e) {}
    if (p && p.catch) p.catch(function (err) {
      if (!opened || (err && err.name === 'AbortError')) return;
      if (!v.muted) {
        v.muted = true; blocked = true; uiSound();
        var q; try { q = v.play(); } catch (e) {}
        if (q && q.catch) q.catch(function (e2) { if (e2 && e2.name !== 'AbortError') big(true); });
      } else big(true);
    });
  }

  function tick() {
    raf = 0; if (!opened) return;
    var d = v.duration, f = fills[idx], n = (clips[idx] && clips[idx].loops) || 1;
    if (f && d > 0) f.style.transform = 'scaleX(' + Math.min(1, (loopN + v.currentTime / d) / n) + ')';
    if (!v.paused) raf = requestAnimationFrame(tick);
  }
  function onPlaying() {
    switching = false; big(false); t0 = Date.now();
    var c = clips[idx]; if (c) { started[c.id] = 1; seenAdd(c.id); paint(); }
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function onPause() {
    flush();
    if (opened && !switching && !holding && !v.ended) big(true);
  }
  function onEnded() {
    flush();
    var c = clips[idx];
    if (c && c.loops > 1 && loopN < c.loops - 1) {
      loopN++;
      try { v.currentTime = 0; } catch (e) {}
      play();
      return;
    }
    if (fills[idx]) fills[idx].style.transform = 'scaleX(1)';
    ga('short_complete', { short_id: c.id, watch_s: Math.round(clipMs / 1000) });
    go(idx + 1);
  }

  function show(i) {
    var c = clips[i]; idx = i; clipMs = 0; loopN = 0; switching = true; big(false);
    curSilent = !!c.silent;
    if (E.snd) E.snd.hidden = curSilent;
    if (curSilent) { v.muted = true; silentMuted = true; }
    else if (silentMuted) { v.muted = false; silentMuted = false; }
    uiSound();
    v.poster = c.poster || '';
    v.setAttribute('aria-label', c.alt || c.label || '');
    v.src = pick(c);
    E.tag.textContent = c.tag || ''; E.tag.hidden = !c.tag;
    E.thumb.hidden = !c.img; if (c.img) E.thumb.src = c.img;
    E.title.textContent = c.title || '';
    E.cta.textContent = cfg.ctaLabel || '';
    if (cfg.ctaMode === 'link') E.cta.href = c.url || '#';
    for (var j = 0; j < fills.length; j++) fills[j].style.transform = j < i ? 'scaleX(1)' : 'scaleX(0)';
    E.sr.textContent = 'فيديو ' + (i + 1) + ' من ' + clips.length;
  }
  function go(i) {
    if (!opened) return;
    if (i >= clips.length) { closePlayer(); return; }
    if (i < 0) { loopN = 0; v.currentTime = 0; play(); return; }
    flush(); show(i); play();
  }

  function open(root, i, btn) {
    use(root); build();
    opener = btn; opened = true; started = {}; totalMs = 0; blocked = false; holding = false;
    E.bars.innerHTML = clips.map(function () { return '<div class="kgs-p__bar"><i></i></div>'; }).join('');
    fills = [].slice.call(E.bars.querySelectorAll('i'));
    try { if (!dlg.open) dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); dlg.classList.add('kgs-p--fb'); }
    lock();
    try { history.pushState({ kgShort: 1 }, ''); pushed = true; } catch (e) {}
    D.querySelectorAll('video').forEach(function (x) { if (x !== v && !x.paused && !x.muted) x.pause(); });
    try { v.dispatchEvent(new CustomEvent('media:started-playing', { bubbles: true, detail: { resource: v } })); } catch (e) {}
    v.muted = false; uiSound();
    show(i); play();
    ga('short_open', { short_id: clips[i].id, short_pos: i + 1, product_handle: clips[i].id });
  }

  function closePlayer() {
    cleanup(); try { if (dlg && dlg.open) dlg.close(); } catch (e) {}
    try { if (opener) opener.focus({ preventScroll: true }); } catch (e) {}
  }
  function cleanup() {
    if (!opened) return; opened = false;
    flush(); cancelAnimationFrame(raf); raf = 0;
    try { v.pause(); v.removeAttribute('src'); v.load(); } catch (e) {}
    unlock(); big(false);
    var n = 0; for (var k in started) n++;
    ga('short_close', { short_id: (clips[idx] || {}).id, watch_s: Math.round(totalMs / 1000), clips_seen: n });
    if (pushed) { pushed = false; try { if (history.state && history.state.kgShort) history.back(); } catch (e) {} }
    try { if (opener) opener.focus({ preventScroll: true }); } catch (e) {}
  }

  W.addEventListener('popstate', function () { if (opened) { pushed = false; closePlayer(); } });
  D.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kgs__item'); if (!b) return;
    var root = b.closest('[data-kgs]'); if (!root) return;
    open(root, +b.getAttribute('data-kgs-i'), b);
  });

  /* short_impression: strip >= 50% visible, once per page */
  function watch() {
    if (!W.IntersectionObserver) return;
    D.querySelectorAll('[data-kgs]').forEach(function (r) {
      if (r.__kgsIo) return; r.__kgsIo = 1;
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); use(r); ga('short_impression', { short_count: clips.length }); }
      }, { threshold: 0.5 });
      io.observe(r);
    });
  }
  paint(); watch();
  D.addEventListener('shopify:section:load', function () { paint(); watch(); });
})();
